import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LocalSettingsService} from './services/local-settings.service';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {UserService} from './services/user-services/user.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {DOCUMENT, isPlatformBrowser, Location, NgForOf, NgIf} from '@angular/common';
import {AuthenticationService} from './services/authentication.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../environments/environment';
import {CustomLoaderComponent} from './shared/components/custom-loader/custom-loader.component';
import {IconComponent} from './shared/components/icons-svgs/icons-svgs.component';
import {PlatformService} from './services/platform-service.service';
import {Notification} from './models/notification';
import {NotificationsComponent} from './shared/components/ux/notifications/notifications.component';
import {filter, finalize, take} from 'rxjs/operators';
import {SchoolService} from './services/school.service';
import {School} from './models/school';
import {AppSharedModule} from './appShared.module';
import {AdminUserService} from './admin/admin-services/admin-user.service';
import {User} from './models/user';
import {Meta, Title} from "@angular/platform-browser";
import { SEOService } from './services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    CustomLoaderComponent,
    RouterOutlet,
    TranslateModule,
    IconComponent,
    NotificationsComponent,
    NgForOf,
    AppSharedModule,
  ]
})

export class AppComponent implements OnInit {
  public loading = true;
  title = 'Livinfrance School';
  userLanguage;
  isBrowser;

  public notificationsArray: Notification[] = [];

  // School switcher
  public settingsOpen: boolean = false;
  public schools: School[];

  // url tracker
  public currentUrl: string = '';
  public isHomePage: boolean = false;
  // Préparation pour le move de la sidenav
  public isAdminPanel: boolean = false;
  public currentUser: User = null;
  private _notifSub$;

  constructor(
    private translate: TranslateService,
    private _localSettings: LocalSettingsService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private mobileDetector: DeviceDetectorService,
    private modalService: NgbModal,
    private router: Router,
    private platformService: PlatformService,
    private schoolService: SchoolService,
    private adminUserService: AdminUserService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: any,
    private pageTitle: Title,
    private meta: Meta,
    private location: Location,
    private seoService: SEOService
  ) {
   this.isBrowser = this.platformService.isBrowserPlatform();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event && event.url) {
        this.currentUrl = event.url;
        if (!environment.robotsIndex || (this.currentUrl.includes('accommodation') || this.currentUrl.includes('school') || this.currentUrl.includes('login'))) {
          this.platformService.setTagContent('robots', 'none');
        } else {
          this.platformService.setTagContent('robots', 'all');

        }
      }
    });

    if (this.isBrowser) {
      this.userLanguage = window?.navigator.language || 'en';
    } else {
      this.userLanguage = 'en';
    }
    if (this.userLanguage != 'fr') {
      this.userLanguage = 'en';
    }

    let path = this.location.path();
    const match = path.match(/^\/(en|fr)(\/|$)/);
    let langLink = match ? match[1] : 'en';
    path = path.replace(/^\/(en|fr)\//, '/');
    if(path == '/en' || path == '/fr'){
      path = '';
    }
    langLink = langLink === 'en' ? 'fr' : 'en';
    /*const hreflanglink = this.document.createElement('link');
    hreflanglink.setAttribute('rel', 'alternate');
    hreflanglink.setAttribute('href', `https://livin-france.com/${langLink}${path}`);
    hreflanglink.setAttribute('hreflang', langLink);
    this.document.head.appendChild(hreflanglink);*/

    translate.setDefaultLang(this.userLanguage);
    let userLang;
    if (this._localSettings.getLanguage()) {
      userLang = this._localSettings.getLanguage();
    } else {
      userLang = this.userLanguage;
      this._localSettings.setLanguage(this.userLanguage);
    }

    this.translate.use(userLang);
    if(userLang && userLang == 'fr'){
      this.pageTitle.setTitle("LivinFrance - Simplifiez votre déménagement en France");
      this.meta.updateTag({name: 'description', content: 'Votre plateforme unique pour les étudiants internationaux déménageant en France. Obtenez de l\'aide pour le visa, le logement, l\'assurance, et plus encore.'});
    }
    else{
      this.pageTitle.setTitle("LivinFrance - Simplify Your Move to France");
      this.meta.updateTag({name: 'description', content: 'Your one-stop platform for international students moving to France. Get help with visa, housing, insurance, and more.'});
    }

    this.userService.isMobileUser = mobileDetector.isMobile();
    this.document.documentElement.lang = userLang;

  }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();

    this.route.queryParams.subscribe(params => {
      //UTM
      if (params && (params['utm_campaign'] || params['utm_source'] || params['utm_medium'])) {
        const utm = [
          { key: 'utm_campaign', value: params['utm_campaign'] ? params['utm_campaign'] : '' },
          { key: 'utm_source', value: params['utm_source'] ? params['utm_source'] : '' },
          { key: 'utm_medium', value: params['utm_medium'] ? params['utm_medium'] : '' },
        ];
        this._localSettings.setUtm(JSON.stringify(utm));
      }
      if (params && params['campaign']) {
        this._localSettings.setReferer(params['campaign']);
      }
      if (params && params['click_id']) {
        this._localSettings.setClickid(params['click_id']);
      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event && event.url) {
        this.currentUrl = event.url;
        this.isAdminPanel = this.currentUrl.toLowerCase().includes('admin');

        if (this.currentUrl !== '/') {
          this.isHomePage = false;
          if (this.isAdminPanel) {

          }
          if (this.authenticationService.currentUserValue) {

            if (!localStorage.getItem('userSession')) {
              this.getUserInformations();
            } else if (!this.currentUser) {
              this.setUserDatas(localStorage.getItem('userSession'));

            }
            // Update des notifications s'il y en a
            if (!this.isAdminPanel && this.currentUser) {
              this.updateNotifications();
            }

          }else {
            this.loading = false;
          }
        } else {
          this.isHomePage = true;
          this.loading = false;
        }
      }
    });
  }

  /**
   * Si connecté :
   * Récupère les datas utilisateurs ;
   * Set les datas utilisateurs dans userService ;
   *
   */
  private getUserInformations(): void {
    this.loading = true;
    this.userService.getDatas(true).subscribe((data: any) => {
      this.setUserDatas(data);
    });
  }

  private setUserDatas(data): void {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
    if (!data) {
      data = this.userService.getDatas();
    }
    this.userService.setInfos(data);
    this.currentUser = data;
    this.notificationsArray = data.notifications;
    this.userService.storeInLocal('userSession', this.currentUser);
    // ADMIN
    if (data && data.isGhost) {
      this.getAdminInformations();
    }
    this.loading = false;
  }

  /**
   * Si admin :
   * Récupère la liste des écoles ;
   *
   */
  private getAdminInformations(): void {
    this.schoolService.getAll().pipe(take(1)).subscribe((data: any) => {
      this.schools = this.sortSchool(data);
    });
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.isActivated || '';
  }

  changeOfRoutes() {
    if (isPlatformBrowser(this.platformId)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.HubSpotConversations) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.HubSpotConversations.widget.refresh();
      }
    }
  }

  public goTo(url): void {
    this.router.navigate([url]);
    this.modalService.dismissAll();
  }

  public trackById(index, item): number {
    return item.id;
  }

  // SCHOOL SWITCHER
  public toggleSettings(): void {
    this.settingsOpen = !this.settingsOpen;
  }

  public chooseSchool(schoolId): void {
    if(this.platformService.isBrowserPlatform()){
      localStorage.removeItem('userSession');
      this.adminUserService.switchSchool(schoolId).pipe(take(1)).subscribe((data: any) => {
        if (data.status == 'success') {
          window.location.reload();
        }
      });
    }

  }

  private sortSchool(data): School[] {
    return data.sort((a, b) => a.name > b.name ? 1 : a.name === b.name ? 0 : -1);
  }

  private updateNotifications(): void {
    let notificationRoute = null;
    let notificationType = null;

    if (this.currentUrl.includes('my-profile')) {
      notificationRoute = 'my-profile';
    }
    if (this.currentUrl.includes('housing-certificate')) {
      notificationType = 'housing-certificate';
    }
    if (this.currentUrl.includes('accommodation') &&
      (!this.currentUrl.includes('list') && !this.currentUrl.includes('property') && !this.currentUrl.includes('informations') && !this.currentUrl.includes('payment'))) {
      notificationType = 'booking';
    }
    if (this._notifSub$) {
      this._notifSub$.unsubscribe();
    }
    this._notifSub$ = this.userService.seenNotifications(notificationRoute, notificationType).pipe(
      finalize(() => {
        this.currentUser = this.userService.userInformations;
        this.notificationsArray = this.currentUser.notifications;
        this.userService.storeInLocal('userSession', this.currentUser);
      })
    ).subscribe((data: { status: string, notifications: any }) => {
      this.userService.setInfo('notifications', data.notifications);
    });
  }
}
